import type { FC } from 'react'

import type { HomePage } from '@/types/homepage'

import { Footer } from '@/components/elements/footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { HomepageContent } from '@/components/pages/homepage/HomepageContent'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

import { useSetTrackingSection } from '@/lib/hooks/useSetTrackingSection'
import { generateSEOAlternateUrls } from '@/lib/utils/localisationUtils'

export type HomepageProps = {
  page: HomePage
}

export const Homepage: FC<HomepageProps> = ({ page }) => {
  useSetTrackingSection('homepage')

  return (
    <>
      <SEOMetaTags metaData={page.metadata} alternateUrls={generateSEOAlternateUrls('/')} />

      <Header />

      <HomepageContent content={page.content} />

      <Footer showPreFooter />
    </>
  )
}
